import { types } from "@fraction/shared";

/** JSON replacer that tags Dates and Decimals so `persistedJsonReviver` restores them as instances. */
export function persistedJsonReplacer(this: any, key: string, value: unknown) {
  const raw = this[key];
  if (!raw || typeof raw !== "object") return value;
  if (raw instanceof Date) return { __t: "D", v: raw.toISOString() };
  if (types.isDecimal(raw)) return { __t: "Dc", v: raw.toString() };
  return value;
}

export const persistedJsonReviver = (_key: string, value: unknown) => {
  if (value && typeof value === "object" && "__t" in value && "v" in value) {
    const tagged = value as { __t: string; v: string };
    if (tagged.__t === "D") return new Date(tagged.v);
    // Revive Decimals as Decimal instances (not numbers) — that's the runtime
    // representation the app uses (entities apply `@Transform(DecimalToNumber())`,
    // which actually builds `new Decimal(...)` on plainToInstance). Reviving to a
    // number here was why restored data looked "wonky" and had to be rebuilt with
    // plainToInstance on every read. Applications are still rebuilt once on restore —
    // see `hydrateApplications` in queryPersister.
    if (tagged.__t === "Dc") return new types.Decimal(tagged.v);
  }
  return value;
};
